export const FETCH_SUB_CATEGORIES_REQUEST = 'FETCH_SUB_CATEGORIES_REQUEST';
export const FETCH_SUB_CATEGORIES_SUCCESS = 'FETCH_SUB_CATEGORIES_SUCCESS';
export const FETCH_SUB_CATEGORIES_FAILURE = 'FETCH_SUB_CATEGORIES_FAILURE';

export const ADD_SUB_CATEGORY_REQUEST = 'ADD_SUB_CATEGORY_REQUEST';
export const ADD_SUB_CATEGORY_SUCCESS = 'ADD_SUB_CATEGORY_SUCCESS';
export const ADD_SUB_CATEGORY_FAILURE = 'ADD_SUB_CATEGORY_FAILURE';

export const UPDATE_SUB_CATEGORY_REQUEST = 'UPDATE_SUB_CATEGORY_REQUEST';
export const UPDATE_SUB_CATEGORY_SUCCESS = 'UPDATE_SUB_CATEGORY_SUCCESS';
export const UPDATE_SUB_CATEGORY_FAILURE = 'UPDATE_SUB_CATEGORY_FAILURE';

export const DELETE_SUB_CATEGORY_REQUEST = 'DELETE_SUB_CATEGORY_REQUEST';
export const DELETE_SUB_CATEGORY_SUCCESS = 'DELETE_SUB_CATEGORY_SUCCESS';
export const DELETE_SUB_CATEGORY_FAILURE = 'DELETE_SUB_CATEGORY_FAILURE';

export const SET_SUB_CATEGORY_EDIT = 'SET_SUB_CATEGORY_EDIT';
export const CLEAR_SUB_CATEGORY_EDIT = 'CLEAR_SUB_CATEGORY_EDIT'; 